	$(function(){
		
// THEME
// ---------------------------------------	
		
		// Detech IE7
		IE7 = (navigator.appVersion.indexOf("MSIE 7.")==-1) ? false : true;
		IE9 = (navigator.appVersion.indexOf("MSIE 9.")==-1) ? false : true;
		
		
		// Philip McLaughlin - Format Image

			$.fn.formatImages = function(height,width,callback) {
				
						if(IE9 == true) {
							var osrc = $(this).attr('src');
							var msrc = osrc.split('?');
							$(this).attr('src',msrc[0]);
						};
						
			    $(this).imagesLoaded( function(){
							var tch = height;
							var tih = $(this).height();
							var ho = ( tch - tih ) / 2;
							var tcw = width;
							var tiw = $(this).width();
					
							if ( tih < tch) {
								$(this).css('margin-top', ho).fadeIn();
							}
							else if ( tih > tch && tiw <= tcw ) {
								$(this).css('height', tch ).fadeIn();
							}
							else {
								$(this).fadeIn();
							};
							
							$(this).addClass('processed');
							
					});
						
			};
		
		// Paul Irish - $.imagesLoaded
		
			// $.fn.imagesLoaded = function(callback){
			// 						  var elems = this.filter('img'),
			// 						      len   = elems.length,
			// 						      blank = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
			// 
			// 						  elems.bind('load.imgloaded',function(){
			// 						      if (--len <= 0 && this.src !== blank){ 
			// 						        elems.unbind('load.imgloaded');
			// 						        callback.call(elems,this); 
			// 						      }
			// 						  }).each(function(){
			// 												
			// 						     // cached images don't fire load sometimes, so we reset src.
			// 						     if (this.complete || this.complete === undefined){
			// 												
			// 						        var src = this.src;
			// 						        // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
			// 						        // data uri bypasses webkit log warning (thx doug jones)
			// 						        this.src = blank;
			// 						        this.src = src;
			// 						     }  
			// 						  }); 
			// 
			// 						  return this;
			// 						}; 
		
		// General
		
			
			// Input Field Formatting
			
				// Search 
					$('#q-span').click(function(){
						$(this).fadeOut(150);
						$('#search-field').focus();
					});
				
					$('#search-field').blur(function(){
						if ($(this).val() == '') {
							$('#q-span').fadeIn(150);
						}
					});
				
				// Subscribe
					$('#fq-span').click(function(){
						$(this).fadeOut(150);
						$('#newsletter-field').focus();
					});

					$('#newsletter-field').blur(function(){
						if ($(this).val() == '') {
							$('#fq-span').fadeIn(150);
						}
					});
			
		
			// Drop Down Navigation
			
				$("li.drop-hover").mouseenter(function(){
				    	
							$('div.sub-menu').show();
						  $("li.drop-hover a").css('background-color','#788082');
							if( $(this).hasClass('current') ){
									$("li.drop-hover a").css('color','#eeeeee');
							};
						
				}).mouseleave(function(){
					
				      $('div.sub-menu').hide();
			  			$("li.drop-hover a").css('background-color','#00ff36');
							if( $(this).hasClass('current') ){
									$("li.drop-hover a").css('color','#00ff36');
							};
							
				});
	
				$("li.smart-drop").mouseenter(function(){
					  
						var tsd = $(this).attr('id');
				    $('#' + tsd + ' div.smart-sub-menu').show();
					  $('#' + tsd + '  a').css('background-color','#eeeeee');
                      /*this bg-color is the submenu color  */
					
						if( $(this).hasClass('current') ){
								$("li.drop-hover a").css('color','#ffffff');
						};
					
				}).mouseleave(function(){
				      $('div.smart-sub-menu').hide();
					  $("li.smart-drop a").css('background-color','#ffffff');
                      //this needs to be the color of the header bg to match
					
						if( $(this).hasClass('current') ){
								$("li.drop-hover a").css('color','#393e3f');
						};
				});
		
			// Format logo text
			
				// 1. Center header text
					
			//		if($('#logo h1 a').text().length > 9){
			//			$('#logo h1 a').css('font-size','27px');
			//		}
			//		
			//		
			//			$('#logo').css('height',$('#header').height());
			//			var mt = (($('#header').height() - $('#logo h1').height()) / 2) -1;
			//			$('#logo h1').css('margin-top', mt).animate({opacity:1});
			//				
		
				// 2. Center footer text
				
			//		if($('#footer-logo h2 a').text().length > 9){
		//				$('#footer-logo h2 a').css('font-size','27px');
		//			}
		//		
		//			
		//				$('#footer-logo').css('height',$('#footer-meta').height());
		//				var mt = (($('#footer-meta').height() - $('#footer-logo h2').height()) / 2) - 1;
		//				$('#footer-logo h2').css('margin-top', mt).animate({opacity:1});
		//			
					
			
				// 3. Fade twitter-glyph in
				
					$('#twitter-glyph-inner img').imagesLoaded(function(){
						$('#twitter-glyph').fadeTo('fast',1);
					});

				


// INDEX 	
// ---------------------------------------			
		
		// Slideshow
		
			// Setup
				var sw = 980 													// Slide width
				var cp = 0														// Current position
				var slides = $('.slide');										// Gather all slides
				var ns = slides.length	- 1										// Number of slides
				var tsc = 0
				var autoSlideID;
			
				$('#theSlider').css('width', (ns + 1) * sw);					// Set the width of 'theSlider'
				
				
				$('.slide img').each(function(){
					$(this).imagesLoaded(function(){

						$('.slide').show();

							

						tsc++;

					});
				});
				
				
				if ( ns > 0 ) {
					$('#slide-next').fadeIn();
				};
				
			// Basic functions
		
				function nextSlide() {
					
					if ( cp != ns ) {
						
						$('#slide-controls li#' + cp).removeClass('focused');
						cp++
						$('#slide-controls li#' + cp).addClass('focused');

						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						
					}

					if ( cp == ns ) {
						$('#slide-next').fadeOut();
					}

					if ( cp > 0 ) {
						$('#slide-prev').fadeIn();
					}
						
					
				
				};
		
				function previousSlide() {
					
					if ( cp != 0 ) {
					
						$('#slide-controls li#' + cp).removeClass('focused');
						cp--
						$('#slide-controls li#' + cp).addClass('focused');

						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						
					};

					if ( cp < ns ) {
						$('#slide-next').fadeIn();	
					}

					if ( cp == 0 ) {
						$('#slide-prev').fadex();
					}
						
					
				
				};
		
				function resetSlides() {
					$('#theSlider').animate({
						marginLeft: 0
					});
					
					$('#slide-controls li').removeClass('focused');
					$('#slide-controls li#0').addClass('focused');
					
					$('#slide-next').fadeIn();
					$('#slide-prev').fadeOut();
					
					cp = 0
					
				};
				
				function autoSlide() {
					
					if ( ns > 0 ) {
						
						if ( cp < ns ) {
							nextSlide();
							if ( cp == ns ) {
								$('#slide-next').fadeOut();
							}
							return false;
						}
						
						if ( cp == ns ) {
							resetSlides();
							return false;
						}
						
					}
					
				};
				
				
				
				
			
			// Build slide controls
				if (ns > 0) {
					$(slides).each(function(i){
						$('#slide-controls').append('<li class="" id='+i+'>&#8226;</li>');
						if ( i == 0 ) {
							$('li#0').addClass('focused');
						};
					});	
				};
		
			// Move to particular slide
				$('#slide-controls li').each(function(i) {
					$(this).click(function(){
						
						
						
						cp = this.id;
						$('#theSlider').animate({
							marginLeft: sw * (-cp)
						});
						$('#slide-controls li').removeClass('focused');
						$(this).addClass('focused');
						
						if ( cp == ns ) {
							$('#slide-next').fadeOut();
						}

						if ( cp > 0 ) {
							$('#slide-prev').fadeIn();
						}
						
						if ( cp < ns ) {
							$('#slide-next').fadeIn();	
						}

						if ( cp == 0 ) {
							$('#slide-prev').fadeOut();
						}
						
					});
				});	
			
			// Move to next slide
				$('#slide-next').click(function(){		
					
							
									
					nextSlide();
				});
		
			// Move to previous slide
				$('#slide-prev').click(function(){
					
					
					
					previousSlide();
				});

		
		//Custom code by Kory Mathis
        
        //End custom code
					
		
		// Set front-page product heights
		
			var ph = 0
		
			$('.product-meta').each(function(){
				if ($(this).height() > ph ) {
					ph = $(this).height();
				}
			});
		
			$('.product-meta').css('height', ph);
		
		
// COLLECTIONS 
// ---------------------------------------
		

		// Set catalogue product heights
		
			var cph = 0
		
			$('.collection-meta').each(function(){
				if ($(this).height() > cph ) {
					cph = $(this).height();
				}
			});
		
			$('.collection-meta').css('height', cph);



// ---------------------------------------
	});
	
	
	
	
	
	
	
	
	
	
	
	